export const addSecondsToCurrentTime = (seconds: number) => {
  const currentDate = new Date();
  const newDate = new Date(currentDate.getTime() + seconds);
  return newDate.getTime();
};
